import React from 'react';

import { CategoryTreeType } from '../../../services/category/view-model/CategoryViewModel';
import UniqueId from '../../../services/uid/UniqueId';
import { useAppSelector } from '../../../store/hooks';
import { getCategoryTreeType } from '../../../store/selectors/category';
import {
  getFormRelatedCategory,
  getFormRelatedTree,
} from '../../../store/selectors/form';
import { CatalogsTreeProps } from '../dm-tree/CatalogsTree';
import CatalogsTreeContainer from '../dm-tree/CatalogsTreeContainer';
import { HierarchyTreeProps } from '../dm-tree/HierarchyTree';
import HierarchyTreeContainer from '../dm-tree/HierarchyTreeContainer';

import { TFormControlConnectorProps } from './FormControlContainer';

const FormTreeControl: React.FC<TFormControlConnectorProps> = ({
  formId,
  onChange,
}) => {
  const category = useAppSelector(state =>
    getFormRelatedCategory(state, formId)
  );

  const treeType = useAppSelector(state =>
    getCategoryTreeType(state, category)
  );

  const treeId = useAppSelector(state => getFormRelatedTree(state, formId));

  const commonTreeProps: Partial<CatalogsTreeProps & HierarchyTreeProps> & {
    treeId: UniqueId;
  } = {
    treeId,
    allowRefresh: false,
    style: { minHeight: `50vh` },
    hideCheckbox: true,
    hideCommands: true,
    onSelect: onChange,
  };

  return treeType === CategoryTreeType.CATALOGS ? (
    <CatalogsTreeContainer {...commonTreeProps} />
  ) : treeType === CategoryTreeType.HIERARCHY ? (
    <HierarchyTreeContainer {...commonTreeProps} />
  ) : null;
};

export default FormTreeControl;
